import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpResponse, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Phone, IPhone} from '../../shared/model/phone.model';
import {PhoneService} from './phone.service';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Customer, ICustomer} from '../../shared/model/customer.model';
import {GlobalConfig, ToastrService} from 'ngx-toastr';
// import moment = require("jalali-moment");

import * as moment from 'jalali-moment';
import {DpDatePickerModule} from 'ng2-jalali-date-picker';
import {IPhoneType} from '../../shared/model/phone-type.model';
import {PhoneTypeService} from '../phone-type/phone-type.service';
import {IPosition} from '../../shared/model/position.model';
import {PositionService} from '../position/position.service';
//import {PHONE_NUMBER_ALREADY_USED_TYPE} from "../../shared/constants/error.constants";
import {CustomerService} from '../customer/customer.service';
import {PositionUpdateComponent} from '../position/position-update.component';
import {PhoneTypeUpdateComponent} from '../phone-type/phone-type-update.component';
import {Organization} from '../../shared/model/organization.model';
import {NgxSpinnerService} from "ngx-spinner";
import {FormBuilder, Validators} from '@angular/forms';
import {ISupplier, Supplier} from "../../shared/model/supplier.model";
import {SupplierService} from "../supplier/supplier.service";
import {SHOW_STORE} from "../../app.constants";

@Component({
  selector: 'app-phone-update',
  templateUrl: './phone-update.component.html'
})
export class PhoneUpdateComponent implements OnInit {
  phone: IPhone = new Phone();
  isSaving: boolean;
  show_store: any = SHOW_STORE;

  phones: IPhone[];
  @Input() phone_param;
  @Input() phone_customer_title;
  @Input() phoneEdit;
  @Input() customerId;
  @Input() supplierId;
  @Input() action;
  customer: ICustomer = new Customer();
  supplier: ISupplier = new Supplier();

  options: GlobalConfig;
  dateObject = moment('1395-11-22', 'jYYYY,jMM,jDD');
  phoneTypes: IPhoneType[];
  positions: IPosition[];
  public serverValidationError = false;
  public serverValidationAudienceError = false;
  customers: ICustomer[];
  suppliers: ISupplier[];

  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  keyword = 'title';

  selectEvent(item) {
    this.phone.customer = new Customer(item.id);
  }
selectEventSuppliers(item) {
    this.phone.supplier = new Supplier(item.id);
  }

  onChangeSearch(val: string) {
    this.customer.title = val;
    this.search(this.page);
  }

  onChangeSearchSuppliers(val: string) {
    this.supplier.title = val;
    this.searchSuppliers(this.page);
  }

  onFocused(e) {
  }
  editForm = this.fb.group({
    id: [null],
    firstName: ['', [Validators.maxLength(50)]],
    lastName: ['', [Validators.required, Validators.maxLength(50)]],
    jhiType: ['', [Validators.required, Validators.maxLength(50)]],
    gender: [''],
    prefix: [''],
    audience: [''],
    position: [''],
    description: ['', [Validators.maxLength(255)]],
    jhiNumber: ['', [Validators.required, Validators.pattern(/^-?(0|[0-9]\d*)?$/)
      , Validators.minLength(8), Validators.maxLength(11)]],
    toNumber: ['' ,[Validators.pattern(/^-?(0|[0-9]\d*)?$/)]],
    jhiMaster: ['',[Validators.pattern(/^-?(0|[0-9]\d*)?$/)]],
  });

  constructor(protected phoneService: PhoneService, protected activatedRoute: ActivatedRoute,
              public activeModal: NgbActiveModal, private toastr: ToastrService,
              protected customerService: CustomerService,
              private modalService: NgbModal,
              private router: Router,
              private fb: FormBuilder,
              private spinner: NgxSpinnerService,
              protected positionService: PositionService,
              protected supplierService: SupplierService,
              protected phoneTypeService: PhoneTypeService) {
    this.options = this.toastr.toastrConfig;
    this.options.positionClass = 'toast-top-center';
    this.options.progressBar = true;
    this.itemsPerPage = 1000;
    this.page = 1;
    this.predicate = 'itemName';
    this.reverse = 'asc';

  }

  ngOnInit() {
    // alert(' this.phone_param' + this.phone_param);
    if (this.phone_param) {
      this.phone.jhiNumber = this.phone_param;
    }
    // alert(' this.phone_customer_title' + this.phone_customer_title);
    if (this.phone_customer_title) {

      this.phone.audience = this.phone_customer_title;
    }
    this.isSaving = false;
// alert(' in init ==' + this.phoneEdit);
    if (this.phoneEdit) {
      this.phoneService.find(this.phoneEdit).subscribe(
        (res: HttpResponse<IPhone>) => {
          this.phone = res.body;
          this.updateForm(this.phone);

          // alert(this.phone);
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }
    this.loadAllPhoneTypes();
    this.loadAllPosition();
    // this.loadAllCustomer();
    this.searchSuppliers(1);

    // this.activatedRoute.data.subscribe(({phone}) => {
    //   this.phone = phone;
    // });
  }



  search(page) {

    if (page) {
      this.page = page;
    } else {
      this.page = 1;

    }

    this.spinner.show();

    const title = (this.customer.title ? this.customer.title : '');

    this.customerService
      .searchAnutocomplete({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: ['title,asc'],
        title

      })
      .subscribe(
        (res: HttpResponse<ICustomer[]>) => this.paginateCustomers(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );

  }

  searchSuppliers(page) {

    if (page) {
      this.page = page;
    } else {
      this.page = 1;

    }

    this.spinner.show();

    const title = (this.customer.title ? this.customer.title : '');

    this.supplierService
      .query({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: ['title,asc']
        // title

      })
      .subscribe(
        (res: HttpResponse<ICustomer[]>) => this.paginateSuppliers(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );

  }


  protected paginateCustomers(data: ICustomer[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.customers = data;
    this.spinner.hide();
  }
  protected paginateSuppliers(data: ICustomer[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.suppliers = data;
    this.spinner.hide();
  }

  loadAllCustomer() {
    this.customerService.query().subscribe((res: HttpResponse<ICustomer[]>) => {
      this.customers = res.body;
    }, (res: HttpErrorResponse) => this.onError(res.message));
  }

  protected onError(errorMessage: string) {
    // this.jhiAlertService.error(errorMessage, null, null);
  }

  previousState() {
    window.history.back();
  }


  loadAllPhoneTypes() {
    this.phoneTypeService.query({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort(this.predicate, this.reverse)
      }
    ).subscribe(
      (res: HttpResponse<IPhoneType[]>) => {
        this.phoneTypes = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  sort(predicate, reverse) {
    let result = ['itemName, asc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }


  loadAllPosition() {
    this.positionService.query({
      page: this.page - 1,
      size: this.itemsPerPage,
      sort: this.sort(this.predicate, this.reverse)
    }).subscribe(
      (res: HttpResponse<IPosition[]>) => {
        this.positions = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  private updateForm(phone: IPhone): void {
    this.editForm.patchValue({
      id: phone.id,
      firstName: phone.firstName,
      lastName: phone.lastName,
      jhiType: phone.jhiType,
      jhiNumber: phone.jhiNumber,
      jhiMaster: phone.jhiMaster,
      toNumber: phone.toNumber,
      position: phone.position,
      gender: phone.gender,
      prefix: phone.prefix,
      audience: phone.audience,
      description: phone.description,
    });
  }

  private updatePhone(phone: IPhone): void {
    phone.firstName = this.editForm.get(['firstName']).value;
    phone.lastName = this.editForm.get(['lastName']).value;
    phone.toNumber = this.editForm.get(['toNumber']).value;
    phone.jhiMaster = this.editForm.get(['jhiMaster']).value;
    phone.jhiType = this.editForm.get(['jhiType']).value;
    phone.position = this.editForm.get(['position']).value;
    phone.jhiNumber = this.editForm.get(['jhiNumber']).value;
    phone.gender = this.editForm.get(['gender']).value;
    phone.prefix = this.editForm.get(['prefix']).value;
    phone.audience = this.editForm.get(['audience']).value;
    phone.description = this.editForm.get(['description']).value;
  }



  save() {

    if ((this.customerId || this.phone.customer !== undefined)  || this.supplierId  ) {


      this.updatePhone(this.phone);
      let temp = '';
      if (this.phone.gender === 'Female') {
        temp = 'خانم ' + temp;
      } else if (this.phone.gender === 'Male') {
        temp = 'آقای ' + temp;
      }

      if (this.phone.prefix) {
        temp = temp + this.phone.prefix + ' ';
      }

      if (this.phone.firstName) {
        temp = temp + this.phone.firstName + ' ';
      }

      if (this.phone.lastName) {
        temp = temp + this.phone.lastName;
      }


      this.phone.audience = temp;
      this.isSaving = true;
      if (this.phone.id !== undefined) {
        this.subscribeToSaveResponse(this.phoneService.update(this.phone));
      } else {
        // alert(' customerId = '+ this.customerId);
        if (this.customerId && !this.phone.customer) {
          this.phone.customer = new Customer(this.customerId);
          // alert(' customer = ' + this.phone.customer);
        }
        if (this.supplierId && !this.phone.supplier) {
          this.phone.supplier = new Supplier(this.supplierId);
          // alert(' customer = ' + this.phone.customer);
        }
        this.subscribeToSaveResponse(this.phoneService.create(this.phone));
      }
    } else {
      alert(' کاربر گرامی لطفاً مشتری مرتبط را انتخاب کنید. ');

    }
    // alert('date==' + this.dateObject);
    // alert('date==' + this.dateObject.format('jYYYY/jMM/jDD'));
    // this.phone.organization = new Organization(1);

    // this.isSaving = true;
    // if (this.phone.id !== undefined) {
    //   this.subscribeToSaveResponse(this.phoneService.update(this.phone));
    // } else {
    //   // alert(' customerId = '+ this.customerId);
    //   if(this.customerId && !this.phone.customer) {
    //     this.phone.customer = new Customer(this.customerId);
    //     // alert(' customer = ' + this.phone.customer);
    //   }
    //   this.subscribeToSaveResponse(this.phoneService.create(this.phone));
    // }
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<IPhone>>) {
    result.subscribe((res: HttpResponse<IPhone>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected subscribeToSaveResponse4(result: Observable<HttpResponse<IPhone>>) {
    result.subscribe((res: HttpResponse<IPhone>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.processError(res));
  }

  protected subscribeToSaveResponse5(result: Observable<HttpResponse<IPhone>>) {
    result.subscribe((res: HttpResponse<IPhone>) => this.onSaveSuccess(), (res: HttpErrorResponse) => this.processErrorAudience(res));
  }

  protected onSaveSuccess() {
    this.isSaving = false;
    this.activeModal.dismiss('cancel');
    this.toastr.success('     ثبت با موفقیت انجام شد.      ', '   کاربر گرامی!    ');

    // this.previousState();
  }

  protected onSaveError() {
    this.isSaving = false;
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }


  searchPhones() {

    // this.spinner.show();

    const number = (this.phone.jhiNumber ? this.phone.jhiNumber : '');

    this.phoneService
      .search({
        page: 0,
        size: 5,
        sort: this.sort2(),
        number
      })
      .subscribe(
        (res: HttpResponse<IPhone[]>) => this.paginatePhones(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }

  protected paginatePhones(data: IPhone[], headers: HttpHeaders) {
    this.phones = data;

    this.spinner.hide();


  }

  sort2() {
    const result = ['audience, asc'];
    return result;
  }


  public showProfile(data) {
// alert(' ppororoor=='+data);
    this.router.navigate(['page/profile-customer/', data]);
    this.clear();
  }


  onKeyUpChangePhoneNumber(val) {
    this.serverValidationError = false;
    if (val) {
      this.phone.jhiNumber = val;
    }
    // this.subscribeToSaveResponse3(
    //   this.phoneService.createValidationNumber(this.phone));

    // if (this.phone.id !== undefined) {
    this.subscribeToSaveResponse4(this.phoneService.createValidationNumber(this.phone));
    // }
  }


  onKeyUpChangeAudienceNumber(val) {
    this.serverValidationAudienceError = false;
    if (val) {
      this.phone.audience = val;
    }
    // this.subscribeToSaveResponse3(
    //   this.phoneService.createValidationNumber(this.phone));

    // if (this.phone.id !== undefined) {
    this.subscribeToSaveResponse5(this.phoneService.createValidationAudience(this.phone));
    // }
  }


  processError(response) {
    if (response.status === 400) {
      this.serverValidationError = true;
      this.searchPhones();
    }
  }

  processErrorAudience(response) {
    if (response.status === 400) {
      this.serverValidationAudienceError = true;
    }
  }

  subscribeToSaveResponse3(result: Observable<IPhone>) {
// alert(' in subscribeToSaveResponse3');
    result.subscribe((res: IPhone) =>
        this.onSaveSuccess2(res)
      , (response) => this.processError(response)
    );
  }


  onSaveSuccess2(result: IPhone) {
    this.isSaving = false;
  }


  addPosition() {


    const modalRef = this.modalService.open(PositionUpdateComponent, {windowClass: 'lg', backdrop: 'static'});
    // modalRef.componentInstance.type = 'Task';
    // modalRef.componentInstance.customerId = this.customer.id;

    modalRef.result.then(
      res => {
        this.loadAllPosition();
      },
      rejected => {
        this.loadAllPosition();
      }
    );

  }

  addPhoneType() {


    const modalRef = this.modalService.open(PhoneTypeUpdateComponent, {windowClass: 'lg', backdrop: 'static'});
    // modalRef.componentInstance.type = 'Task';
    // modalRef.componentInstance.customerId = this.customer.id;

    modalRef.result.then(
      res => {
        this.loadAllPhoneTypes();
      },
      rejected => {
        this.loadAllPhoneTypes();
      }
    );

  }

}
